export const SET_FORMS = 'SET_FORMS'
export const SET_FORM = 'SET_FORM'
export const SET_FIELDS = 'SET_FIELDS'
export const SET_FIELD_TYPES = 'SET_FIELD_TYPES'
export const SET_FIELD_TYPES_GROUPED = 'SET_FIELD_TYPES_GROUPED'
export const SET_SELECTED_FIELD = 'SET_SELECTED_FIELD'
export const SET_CONDITIONS = 'SET_CONDITIONS'
export const SET_OPERATORS = 'SET_OPERATORS'
export const SET_ACTIONS = 'SET_ACTIONS'
export const SET_IS_DIRTY = 'SET_IS_DIRTY'
export const SET_IS_LOADING = 'SET_IS_LOADING'

// Local field mutations (for builder)
export const ADD_FIELD = 'ADD_FIELD'
export const UPDATE_FIELD = 'UPDATE_FIELD'
export const REMOVE_FIELD = 'REMOVE_FIELD'
export const REORDER_FIELDS = 'REORDER_FIELDS'

// Local condition mutations
export const ADD_CONDITION = 'ADD_CONDITION'
export const UPDATE_CONDITION = 'UPDATE_CONDITION'
export const REMOVE_CONDITION = 'REMOVE_CONDITION'
